
webpack.register(
    'blocks/partner-link/partner-link',
    function() {
        return import('blocks/partner-link/partner-link');
    },
    true
);